// extracted by mini-css-extract-plugin
export var container = "_br-1";
export var cornerButtonContainer = "_br-5";
export var disabled = "_br-2";
export var fileContainer = "_br-4";
export var hiddenInput = "_br-3";
export var widthContainer = "_br-0";